























































































































































































































































































































































































































































import UserCategories from '@/components/UserCategories.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {
  ChangePassForm,
  ChangeUserEmailForm,
  ChangeUserFIOForm,
  ChangeUserPermissions,
  NotificationsForm,
  SelectBox
} from '@/interfaces/global-data';
import {
  AdditionalRole,
  ConstraintError,
  IdAndName,
  PageParams,
  TradingNetworkTreeItem,
  User,
  UserForm,
  UserPermissions,
  UserRole,
  userRoleSb,
  UserShortInfo,
  UserTradingNetworkTreeItem,
  ValidationResponse,
} from '@/interfaces/server-data';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import Http from '../mixins/http';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import Card from './UI/Card.vue';
import {update} from "lodash";
import Vue from "vue";
@Component({
  methods: {update},
    components: {
      UserCategories,
      vSelect,
      Card,
    },
  })
  export default class Users extends Mixins(Http, Toast, LocalData) {

    currentPage: number = 1;
    totalRows: number = 0;
    perPage: number = 20;
    tableFields: TableHeaders[] = [
      {key: 'id', label: '#'},
      {key: 'username', label: 'Login'},
      {key: 'fio', label: 'Full name'},
      {key: 'email', label: 'Email'},
      {key: 'role', label: 'Role'},
      {key: 'accessToSystemParams', label: 'System parameters access'},
      {key: 'accessToKviCarts', label: 'Baskets & KVI access'},
      {key: 'accessToRevaluation', label: 'Revaluation access'},
      {key: 'accessToEvents', label: 'Events access'},
      {key: 'accessToSettings', label: 'Settings access'},
      {key: 'accessToPromo', label: 'Promo access'},
      {key: 'accessToScenarioAnalysis', label: 'Scenario analysis access'},
      {key: 'accessToOmnichannelStrategy', label: 'Omnichannel strategy access'},
      {key: 'accessToUploads', label: 'Uploads access'},
      {key: 'accessToSupportPage', label: 'Support access'},
      {key: 'accessToMonitoring', label: 'Price monitoring access'},
      {key: 'enabled', label: 'Status'},
      {key: 'action', label: 'Actions'},
    ];

    computedTableFields: any[] = [
      {dataIndex: 'id', title: '#', width: 75, sorter: (a: any, b: any) => a.id - b.id},
      {dataIndex: 'username', title: this.$t('users.table.login') as string, width: 200, ellipsis: true},
      {dataIndex: 'fio', title: this.$t('users.table.fullName') as string, width: 200, ellipsis: true},
      {dataIndex: 'email', title: this.$t('users.table.email') as string, width: 200, ellipsis: true},
      {dataIndex: 'role', title: this.$t('users.table.role') as string, scopedSlots: { customRender: 'role' }, width: 140},
      {dataIndex: 'vice.username', title: this.$t('users.table.deputy') as string, scopedSlots: { customRender: 'vice' }, width: 160, ellipsis: true},
      {dataIndex: 'accessToSystemParams', title: this.$t('users.table.systemParamsAccess') as string, scopedSlots: { customRender: 'accessToSystemParams' }, width: 150},
      {dataIndex: 'accessToResultsMonitor', title: this.$t('users.table.resultsMonitor') as string, scopedSlots: { customRender: 'accessToResultsMonitor' }, width: 150},
      {dataIndex: 'accessToKpiPanel', title: this.$t('users.table.kpiPanel') as string, scopedSlots: { customRender: 'accessToKpiPanel' }, width: 150},
      {dataIndex: 'accessToRegularPrices', title: this.$t('users.table.regularPrices') as string, scopedSlots: { customRender: 'accessToRegularPrices' }, width: 150},
      {dataIndex: 'accessToScenarioAnalysis', title: this.$t('users.table.scenarioAnalysis') as string, scopedSlots: { customRender: 'accessToScenarioAnalysis' }, width: 150},
      {dataIndex: 'accessToKviCarts', title: this.$t('users.table.kviBaskets') as string, scopedSlots: { customRender: 'accessToKviCarts' }, width: 150},
      {dataIndex: 'accessToMonitoring', title: this.$t('users.table.priceMonitoring') as string, scopedSlots: { customRender: 'accessToMonitoring' }, width: 150},
      {dataIndex: 'accessToOmnichannelStrategy', title: this.$t('users.table.omnichannelStrategy') as string, scopedSlots: { customRender: 'accessToOmnichannelStrategy' }, width: 150},
      {dataIndex: 'accessToPackageCalc', title: this.$t('users.table.packageCalc') as string, scopedSlots: { customRender: 'accessToPackageCalc' }, width: 150},
      {dataIndex: 'accessToFixedPricesPage', title: this.$t('users.table.fixedPrices') as string, scopedSlots: { customRender: 'accessToFixedPricesPage' }, width: 150},
      {dataIndex: 'accessToRevaluation', title: this.$t('users.table.revaluation') as string, scopedSlots: { customRender: 'accessToRevaluation' }, width: 150},
      {dataIndex: 'accessToPromo', title: this.$t('users.table.promo') as string, scopedSlots: { customRender: 'accessToPromo' }, width: 150},
      {dataIndex: 'accessToSales', title: this.$t('users.table.sales') as string, scopedSlots: { customRender: 'accessToSales' }, width: 150},
      {dataIndex: 'accessToEvents', title: this.$t('users.table.events') as string, scopedSlots: { customRender: 'accessToEvents' }, width: 150},
      {dataIndex: 'accessToResults', title: this.$t('users.table.results') as string, scopedSlots: { customRender: 'accessToResults' }, width: 150},
      {dataIndex: 'accessToUploads', title: this.$t('users.table.uploads') as string, scopedSlots: { customRender: 'accessToUploads' }, width: 200},
      {dataIndex: 'accessToDataExport', title: this.$t('users.table.dataExportAccess') as string, scopedSlots: { customRender: 'accessToDataExport' }, width: 150},
      {dataIndex: 'accessToSettings', title: this.$t('users.table.settings') as string, scopedSlots: { customRender: 'accessToSettings' }, width: 150},
      {dataIndex: 'accessToSupportPage', title: this.$t('users.table.support') as string, scopedSlots: { customRender: 'accessToSupportPage' }, width: 150},
      {dataIndex: 'accessToSubmitRevaluationForApproval', title: this.$t('users.table.submitRevaluationForApproval') as string, scopedSlots: { customRender: 'accessToSubmitRevaluationForApproval' }, width: 180},
      {dataIndex: 'enabled', title: this.$t('users.table.status') as string, scopedSlots: { customRender: 'status' }, width: 100},
      {dataIndex: 'action', title: this.$t('users.table.actions') as string, width: 100, scopedSlots: { customRender: 'action' }},
    ];

    pagination: any = {
        pageSize: 20,
        current: 1,
    };
    usersList: any = [];
    isTableBusy = true;
    isCategoryBusy = false;
    modalTitle = '';
    userForm: UserForm = {
      username: '',
      role: UserRole.ROLE_USER,
      accessToSystemParams: false,
      enabled: true,
      password: '',
      fio: '',
      email: '',
    };

    dropdownStates: any = {};

    changePassForm: ChangePassForm = {
      uid: -1,
      password: '',
      passwordConfirm: '',
    };

    changeUserFIOForm: ChangeUserFIOForm = {
      uid: -1,
      fio: '',
    };

    changeUserEmailForm: ChangeUserEmailForm = {
      uid: -1,
      email: '',
    };

    notificationsForm: NotificationsForm = {
      uid: -1,
      notifications: {
        loadingErrors: true,
        generatedReport: true,
        revaluationStatusNotification: false,
        revaluationOnFinalApproveStatusNotification: false,
        fixedPriceStatusNotification: false,
        revaluationFtpExportNotification: false,
      },
    };

    changeUserPermissionsForm: ChangeUserPermissions = {
      uid: -1,
      accessToSystemParams: false,
      accessToResultsMonitor: false,
      accessToKpiPanel: false,
      accessToRegularPrices: false,
      accessToScenarioAnalysis: false,
      accessToKviCarts: false,
      accessToMonitoringPrice: false,
      accessToOmnichannelStrategy: false,
      accessToPackageCalc: false,
      accessToFixedPricesPage: false,
      accessToRevaluation: false,
      accessToPromo: false,
      accessToSales: false,
      accessToEvents: false,
      accessToResults: false,
      accessToUploads: false,
      accessToDataExport: false,
      accessToSettings: false,
      accessToSupportPage: false,
      accessToOkrbCodesPage: false,
      accessToSubmitRevaluationForApproval: false,
      accessToUploadsSales: false,
      accessToUploadsCompetitors: false,
      accessToUploadsLastprices: false,
      accessToUploadsKviCarts: false,
      accessToUploadsPromo: false,
    };

    tradingNetworks: IdAndName[] = [];
    tagTree: TradingNetworkTreeItem[] = [];
    userTagTree: UserTradingNetworkTreeItem[] = [];
    userId: number = -1;

    errorKey = 0;
    userFormErrors: { [k: string]: string } = {};
    changePassFormErrors: { [k: string]: string } = {};

    usersChanged = 1;

    adminEnum = UserRole.ROLE_ADMIN;

    readonly SUBMIT_REVALUATION_FOR_APPROVAL_PERMISSION = 'SUBMIT_REVALUATION_FOR_APPROVAL';
    readonly ADMIN_USER_ID = 1;

    isFinalApprover(user: User): boolean {
        return !!user.additionalRoles && user.additionalRoles.includes(AdditionalRole.FINAL_APPROVER);
    }

    getUserRolesOpts() {
      return [
        {value: UserRole.ROLE_USER, label: this.$t('users.roles.user')},
        {value: UserRole.ROLE_ADMIN, label: this.$t('users.roles.administrator')}
      ];
    }

    userToChangeVice: User | null = null;
    usersShortInfoList: UserShortInfo[] = [];
    selectedVice: number | null = null;

    getUserVicesOptions(): SelectBox<number>[] {
      return this.usersShortInfoList.map(userShortInfo => ({
        value: userShortInfo.id,
        label: userShortInfo.username,
      })).filter((item) => this.userToChangeVice != null && this.userToChangeVice.id != item.value)
    }

    handleViceChange(value: number) {
      this.selectedVice = value;
    }

    saveUserVice() {
      if (this.userToChangeVice == null) {
        this.showError(this.$t('users.messages.deputyNotSelected') as string)
        return
      }
      let selectedVice = !!this.selectedVice ? this.selectedVice : null;
      this.httpChangeUserVice(this.userToChangeVice.id, selectedVice)
          .then(() => {
            this.showInfo(this.$t('users.messages.deputyAssigned') as string)

            this.fetchUsers({
              perPage: this.pagination.pageSize,
              currentPage: this.pagination.current,
            }, () => {})
          })
    }

    isUser(role: UserRole) {
      return role === UserRole.ROLE_USER
    }

    isSuperAdmin() {
        return this.$userId === 1
    }

    mounted() {
        this.modalTitle = this.$t('users.modals.createUser') as string;
        const pager = { ...this.pagination };
        pager.current = this.pagination.current;
        this.pagination = pager;
        this.fetchUsers({
            perPage: this.pagination.pageSize,
            currentPage: this.pagination.current,
        }, () => {})
    }

    handleTableChange(pagination: any) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetchUsers({
            perPage: pagination.pageSize,
            currentPage: pagination.current,
        }, () => {});
    }

    handleChangePermissions(data: any) {
      this.changeUserPermissionsForm.uid = data.id;
      this.changeUserPermissionsForm.accessToSystemParams = data.role === 'ROLE_ADMIN' || data.accessToSystemParams;

      const permissionsMap: Partial<Record<keyof ChangeUserPermissions, string>> = {
        accessToResultsMonitor: "RESULTS_MONITOR",
        accessToKpiPanel: "KPI_DASHBOARD",
        accessToRegularPrices: "REGULAR_PRICES",
        accessToScenarioAnalysis: "SCENARIO_ANALYSIS",
        accessToKviCarts: "KVI_CARTS",
        accessToMonitoringPrice: "PRICES_MONITORING",
        accessToOmnichannelStrategy: "OMNICHANNEL_STRATEGY",
        accessToPackageCalc: "PACKAGE_CALCULATION",
        accessToFixedPricesPage: "FIXED_PRICES",
        accessToRevaluation: "REVALUATION",
        accessToPromo: "PROMO",
        accessToSales: "SALES", 
        accessToEvents: "EVENTS",
        accessToResults: "RESULTS",
        accessToUploads: "UPLOADS",
        accessToDataExport: "EXPORT_DATA",
        accessToSettings: "SETTINGS",
        accessToSupportPage: "SUPPORT_PAGE",
        accessToOkrbCodesPage: "OKRB_CODES",
        accessToUploadsSales: "UPLOADS_SALES",
        accessToUploadsCompetitors: "UPLOADS_COMPETITORS",
        accessToUploadsLastprices: "UPLOADS_LASTPRICES",
        accessToUploadsKviCarts: "UPLOADS_KVI_CARTS",
        accessToUploadsPromo: "UPLOADS_PROMO",
        accessToSubmitRevaluationForApproval: this.SUBMIT_REVALUATION_FOR_APPROVAL_PERMISSION,
      };

      (Object.keys(permissionsMap) as Array<keyof ChangeUserPermissions>).forEach((key) => {
        (this.changeUserPermissionsForm as any)[key] = data.permissions.includes(permissionsMap[key]!);
      });
    }

    changeEmailButNotForSuperAdmin(userId: number) {
      return this.$userId === 1 || (this.$userRole === UserRole.ROLE_ADMIN && userId !== 1)
    }

    clearUserForm() {
      this.userForm = {
        username: '',
        role: UserRole.ROLE_USER,
        accessToSystemParams: false,
        enabled: true,
        password: '',
        fio: '',
        email: '',
      };
      this.userFormErrors = {};
    }

    clearPasswdForm() {
      this.changePassForm = {
        uid: -1,
        password: '',
        passwordConfirm: '',
      };
      this.changePassFormErrors = {};
    }

    clearFioForm() {
      this.changeUserFIOForm = {
        uid: -1,
        fio: '',
      };
    }

      clearEmailForm() {
          this.changeUserEmailForm = {
              uid: -1,
              email: '',
          };
      }

    clearUserPermissionsForm() {
      this.changeUserPermissionsForm = {
        uid: -1,
        accessToSystemParams: false,
        accessToResultsMonitor: false,
        accessToKpiPanel: false,
        accessToRegularPrices: false,
        accessToScenarioAnalysis: false,
        accessToKviCarts: false,
        accessToMonitoringPrice: false,
        accessToOmnichannelStrategy: false,
        accessToPackageCalc: false,
        accessToFixedPricesPage: false,
        accessToRevaluation: false,
        accessToPromo: false,
        accessToSales: false,
        accessToEvents: false,
        accessToResults: false,
        accessToUploads: false,
        accessToDataExport: false,
        accessToSettings: false,
        accessToSupportPage: false,
        accessToOkrbCodesPage: false,
        accessToSubmitRevaluationForApproval: false,
        accessToUploadsSales: false,
        accessToUploadsCompetitors: false,
        accessToUploadsLastprices: false,
        accessToUploadsKviCarts: false,
        accessToUploadsPromo: false,
      };
    }

    userFriendlyRoleName(role: UserRole): string {
      return userRoleSb[role].label;
    }

    userRoleVariant(role: UserRole): string {
      switch (role) {
        case UserRole.ROLE_ADMIN:
          return 'orange';
        case UserRole.ROLE_USER:
          return 'blue';
        default:
          return ''
      }
    }

    saveUser(bvModalEvt: Event) {
      const userData = Object.assign({}, this.userForm);
      bvModalEvt.preventDefault();
      this.httpCreateUser(userData)
        .then((resp) => {
          this.usersChanged = Math.random();
          (this.$refs.addEditUser as any).hide();
        })
        .catch((e) => {
          if (e.response.status === 400) {
            const validation: ValidationResponse = e.response.data;
            this.errorKey = Math.random();
            validation.errors.forEach((c: ConstraintError) => {
              this.userFormErrors[c.property] = c.message;
            })
          } else {
            this.showError(this.$t('users.messages.createUserError') as string);
          }
        });
    }

  deleteUser(user: User) {
    this.$bvModal.msgBoxConfirm(this.$t('users.messages.deleteConfirm') as string, {
      headerBgVariant: 'warning',
      title: this.$t('shared.messages.attention') as string,
      size: 'sm',
      buttonSize: 'sm',
      okTitle: this.$t('shared.buttons.yes') as string,
      cancelTitle: this.$t('shared.buttons.no') as string,
      footerClass: 'p-2',
      hideHeaderClose: false,
      noCloseOnEsc: true,
      noCloseOnBackdrop: true,
      centered: true,
    })
        .then((value) => {
          if (!value) {
            return Promise.resolve();
          }

          this.isTableBusy = true;

          return this.httpDeleteUser(user.id)
              .then(() => {
                this.showInfo(this.$t('users.messages.deleteSuccess') as string);
                return this.refreshUsersTable();
              })
              .catch(() => {
                this.showError(this.$t('users.messages.deleteError') as string);
              })
              .finally(() => {
                this.isTableBusy = false;
              });
        });
  }

  refreshUsersTable() {
      this.fetchUsers({
        perPage: this.pagination.pageSize,
        currentPage: this.pagination.current,
      }, () => {});
    }

    validatePassForm(): string {
      return this.changePassForm.password === this.changePassForm.passwordConfirm ? 'valid' : 'invalid';
    }

    changePassword(bvModalEvt: Event) {
      const passData = Object.assign({}, this.changePassForm);
      bvModalEvt.preventDefault();
      this.httpChangeUserPassword(passData.uid, {password: passData.password})
        .then(() => {
          (this.$refs.changeUserPass as any).hide();
        }).catch((e) => {
        if (e.response.status === 400) {
          const validation: ValidationResponse = e.response.data;
          this.errorKey = Math.random();
          validation.errors.forEach((c: ConstraintError) => {
            this.changePassFormErrors[c.property] = c.message;
          });
        } else if (e.response.status === 404) {
          (this.$refs.changeUserPass as any).hide();
          this.showError(this.$t('shared.messages.userNotFound') as string);
        } else {
          this.showError(this.$t('users.messages.changePasswordError') as string);
        }
      });
    }

    changeFio(bvModalEvt: Event) {
      const fioData = Object.assign({}, this.changeUserFIOForm);
      bvModalEvt.preventDefault();
      this.httpChangeUserFio(fioData.uid, fioData.fio)
              .then(() => {
                (this.$refs.changeUserFio as any).hide();
                this.refreshUsersTable();
              }).catch((e) => {
        if (e.response.status === 404) {
          (this.$refs.changeUserFio as any).hide();
          this.showError(this.$t('shared.messages.userNotFound') as string);
        } else {
          this.showError(this.$t('users.messages.changeNameError') as string);
        }
      });
    }

    changeEmail(bvModalEvt: Event) {
      const emailData = Object.assign({}, this.changeUserEmailForm);
      bvModalEvt.preventDefault();
      this.httpChangeUserEmail(emailData.uid, emailData.email)
        .then(() => {
          (this.$refs.changeUserEmail as any).hide();
          this.refreshUsersTable();
        }).catch((e) => {
        if (e.response.status === 404) {
          (this.$refs.changeUserEmail as any).hide();
          this.showError(this.$t('shared.messages.userNotFound') as string);
        } else {
          this.showError(this.$t('users.messages.enterValidEmail') as string);
        }
      });
    }

    changeNotifications(bvModalEvt: Event) {
      const emailData = Object.assign({}, this.notificationsForm);
      bvModalEvt.preventDefault();
      this.httpChangeNotifications(
          emailData.uid, emailData.notifications.loadingErrors,
          emailData.notifications.generatedReport,
          emailData.notifications.revaluationStatusNotification,
          emailData.notifications.revaluationOnFinalApproveStatusNotification,
          emailData.notifications.fixedPriceStatusNotification,
          emailData.notifications.revaluationFtpExportNotification
      )
        .then(() => {
          (this.$refs.notifications as any).hide();
          this.refreshUsersTable();
        }).catch((e) => {
        if (e.response.status === 404) {
          this.showError(this.$t('shared.messages.userNotFound') as string);
        }
      });
    }

    getNotifications() {
      const emailData = Object.assign({}, this.notificationsForm);
      this.httpGetNotifications(emailData.uid)
        .then((response) => {
          let diskSpaceError = false
          let criticalErrors = false
          let warningsWithAttachment = false
          let generatedReport = false
          let revaluationStatusNotification = false
          let revaluationOnFinalApproveStatusNotification = false
          let fixedPriceStatusNotification = false
          let revaluationFtpExportNotification = false
          const arr = response.data
          for (let i = 0; i < arr.length; i++) {
            if (arr[i] === 'diskSpaceError') { diskSpaceError = true }
            if (arr[i] === 'criticalErrors') { criticalErrors = true }
            if (arr[i] === 'warningsWithAttachment') { warningsWithAttachment = true }
            if (arr[i] === 'generatedReport') { generatedReport = true }
            if (arr[i] === 'revaluationStatusNotification') { revaluationStatusNotification = true }
            if (arr[i] === 'revaluationOnFinalApproveStatusNotification') { revaluationOnFinalApproveStatusNotification = true }
            if (arr[i] === 'fixedPriceStatusNotification') { fixedPriceStatusNotification = true }
            if (arr[i] === 'revaluationFtpExportNotification') { revaluationFtpExportNotification = true }
          }
          this.notificationsForm.notifications.loadingErrors =
              diskSpaceError && criticalErrors && warningsWithAttachment;
          this.notificationsForm.notifications.generatedReport = generatedReport;
          this.notificationsForm.notifications.revaluationStatusNotification = revaluationStatusNotification
          this.notificationsForm.notifications.revaluationOnFinalApproveStatusNotification = revaluationOnFinalApproveStatusNotification
          this.notificationsForm.notifications.fixedPriceStatusNotification = fixedPriceStatusNotification
          this.notificationsForm.notifications.revaluationFtpExportNotification = revaluationFtpExportNotification
        }).catch((e) => {
        if (e.response.status === 404) {
          this.showError(this.$t('shared.messages.userNotFound') as string);
        }
      });
    }

    changeUserPermissions(bvModalEvt: Event) {
      const permissionsData = Object.assign({}, this.changeUserPermissionsForm);
      const permissions: string[] = [];
      if (permissionsData.accessToResultsMonitor) { permissions.push('RESULTS_MONITOR') }
      if (permissionsData.accessToKpiPanel) { permissions.push('KPI_DASHBOARD') }
      if (permissionsData.accessToRegularPrices) { permissions.push('REGULAR_PRICES') }
      if (permissionsData.accessToScenarioAnalysis) { permissions.push('SCENARIO_ANALYSIS') }
      if (permissionsData.accessToKviCarts) { permissions.push('KVI_CARTS') }
      if (permissionsData.accessToMonitoringPrice) { permissions.push('PRICES_MONITORING') }
      if (permissionsData.accessToOmnichannelStrategy) { permissions.push('OMNICHANNEL_STRATEGY') }
      if (permissionsData.accessToPackageCalc) { permissions.push('PACKAGE_CALCULATION') }
      if (permissionsData.accessToFixedPricesPage) { permissions.push('FIXED_PRICES') }
      if (permissionsData.accessToRevaluation) { permissions.push('REVALUATION') }
      if (permissionsData.accessToPromo) { permissions.push('PROMO') }
      if (permissionsData.accessToSales) { permissions.push('SALES') }
      if (permissionsData.accessToEvents) { permissions.push('EVENTS') }
      if (permissionsData.accessToResults) { permissions.push('RESULTS') }
      if (permissionsData.accessToUploads) { permissions.push('UPLOADS') }
      if (permissionsData.accessToDataExport) { permissions.push('EXPORT_DATA') }
      if (permissionsData.accessToSettings) { permissions.push('SETTINGS') }
      if (permissionsData.accessToSupportPage) { permissions.push('SUPPORT_PAGE') }
      if (permissionsData.accessToUploadsSales) { permissions.push('UPLOADS_SALES') }
      if (permissionsData.accessToUploadsCompetitors) { permissions.push('UPLOADS_COMPETITORS') }
      if (permissionsData.accessToUploadsLastprices) { permissions.push('UPLOADS_LASTPRICES') }
      if (permissionsData.accessToUploadsKviCarts) { permissions.push('UPLOADS_KVI_CARTS') }
      if (permissionsData.accessToUploadsPromo) { permissions.push('UPLOADS_PROMO') }
      if (permissionsData.accessToSubmitRevaluationForApproval) { permissions.push(this.SUBMIT_REVALUATION_FOR_APPROVAL_PERMISSION) }

      const userPermissions: UserPermissions = {
          accessToSystemParams: permissionsData.accessToSystemParams,
          permissions,
      };
      bvModalEvt.preventDefault();
      this.httpChangeUserPermissions(permissionsData.uid, userPermissions)
              .then(() => {
                (this.$refs.changeUserSystemAccess as any).hide();
                this.refreshUsersTable();
              }).catch((e) => {
        if (e.response.status === 404) {
          (this.$refs.changeUserSystemAccess as any).hide();
          this.showError(this.$t('shared.messages.userNotFound') as string);
        } else {
          this.showError(this.$t('users.messages.changePermissionsError') as string);
        }
      });
    }

    hasAccess(user: User, module: string) {
        return user.role === UserRole.ROLE_ADMIN || user.permissions.includes(module)
    }

    hasSubmitRevaluationForApproval(user: User): boolean {
        if (user.id === this.ADMIN_USER_ID) return true;
        return !!user.permissions && user.permissions.includes(this.SUBMIT_REVALUATION_FOR_APPROVAL_PERMISSION);
    }

    toggleFinalApproverRole(item: User) {
        const wasFinalApprover = this.isFinalApprover(item);
        const messageKey = wasFinalApprover ? 'users.messages.finalApproverRemoved' : 'users.messages.finalApproverAssigned';
        this.httpChangeUserAdditionalRoles(item.id, { [AdditionalRole.FINAL_APPROVER]: !wasFinalApprover })
            .then(() => {
                this.showInfo(this.$t(messageKey) as string);
                this.refreshUsersTable();
            })
            .catch(() => {
                this.showError(this.$t('users.messages.finalApproverChangeError') as string);
            });
    }

    getUploadsAccessInfo(user: User): { hasFullAccess: boolean; submodules: string[]; displayText: string } {
        if (user.role === UserRole.ROLE_ADMIN) {
            return {
                hasFullAccess: true,
                submodules: [],
                displayText: this.$t('users.messages.allAccess') as string
            };
        }

        const hasFullAccess = user.permissions.includes('UPLOADS');
        if (hasFullAccess) {
            return {
                hasFullAccess: true,
                submodules: [],
                displayText: this.$t('users.messages.allAccess') as string
            };
        }

        const uploadsSubmodules = [
            { key: 'UPLOADS_SALES', label: this.$t('users.uploadsSubmodules.sales') as string },
            { key: 'UPLOADS_COMPETITORS', label: this.$t('users.uploadsSubmodules.competitors') as string },
            { key: 'UPLOADS_LASTPRICES', label: this.$t('users.uploadsSubmodules.assortment') as string },
            { key: 'UPLOADS_KVI_CARTS', label: this.$t('users.uploadsSubmodules.kviBaskets') as string },
            { key: 'UPLOADS_PROMO', label: this.$t('users.uploadsSubmodules.promo') as string },
            { key: 'UPLOADS_FIXED_PRICES', label: this.$t('users.uploadsSubmodules.fixedPrices') as string },
            { key: 'UPLOADS_DIRECTORIES', label: this.$t('users.uploadsSubmodules.directories') as string },
            { key: 'UPLOADS_RULES', label: this.$t('users.uploadsSubmodules.rules') as string },
            { key: 'UPLOADS_OTHER', label: this.$t('users.uploadsSubmodules.other') as string }
        ];

        const availableSubmodules = uploadsSubmodules
            .filter(submodule => user.permissions.includes(submodule.key))
            .map(submodule => submodule.label);

        return {
            hasFullAccess: false,
            submodules: availableSubmodules,
            displayText: availableSubmodules.length > 0 
                ? availableSubmodules.join(', ') 
                : this.$t('users.messages.noAccess') as string
        };
    }

    fetchUsers(ctx: any, callback: (items: any[]) => void) {
      this.isTableBusy = true;
      const pageParams: PageParams = {
        size: ctx.perPage, page: ctx.currentPage - 1,
      };
      this.httpFetchUsersList(pageParams)
        .then((resp) => {
          this.pagination.total = resp.data.totalElements;
          this.usersList = resp.data.content.map(i => ({ ...i, key: i.id }));
          this.isTableBusy = false;
        })
        .catch((e) => {
          this.showError(this.$t('users.messages.loadUsersError') as string);
          callback([]);
          this.isTableBusy = false;
        })
    }

    changeUserStatus(user: User) {
      this.httpChangeUserStatus(user.id)
        .then((result) => {
          user.enabled = result.data.enabled
          this.refreshUsersTable();
        })
        .catch((e) => {
          if (e.response.status === 404) {
            this.showError(this.$t('shared.messages.userNotFound') as string)
          } else {
            this.showError(this.$t('users.messages.changeStatusError') as string);
          }
        })
    }

    changeUserRole(user: User) {
      this.httpChangeUserRole(user.id)
        .then((result) => {
          user.role = result.data.role
          this.refreshUsersTable();
        })
        .catch((e) => {
          if (e.response.status === 404) {
            this.showError(this.$t('shared.messages.userNotFound') as string)
          } else {
            this.showError(this.$t('users.messages.changeRoleError') as string);
          }
        })
    }

    changeUserVice(user: User) {
      this.userToChangeVice = user
      this.selectedVice = user.vice ? user.vice.id : null
      this.httpFetchUsersShortInfoList()
          .then((r) => {
            this.usersShortInfoList = r.data
          })
    }

    getTradingNetworks(uid: number) {
      this.userId = uid;
      this.httpGetTradingNetworks()
        .then((r) => {
          this.tradingNetworks = r.data;
          this.getUserTags(uid);
        })
        .catch((e) => {
          this.showError(this.$t('shared.messages.loadTradingCompaniesError') as string);
        });
    }

    getUserTags(uid: number) {
      this.httpGetUserTags(uid)
        .then((r) => {
          this.userTagTree = r.data;
          const checkedTns = new Map<number, number>();
          this.userTagTree.forEach((tn) => checkedTns.set(tn.id, tn.isChecked ? 2 : 1))
          this.tagTree = this.tradingNetworks.map((tn) => ({
            id: tn.id,
            name: tn.name,
            groups: [],
            isOpen: false,
            checked: checkedTns.has(tn.id) ? checkedTns.get(tn.id)! : 0,
            key: -1,
            isLoading: true,
          }));
        })
        .catch((e) => {
          this.showError(this.$t('shared.messages.loadTradingCompaniesError') as string);
        });
    }

    clearTags() {
      this.tradingNetworks = [];
      this.tagTree = [];
    }

    created() {
      if (this.$userRole !== UserRole.ROLE_ADMIN) {
        this.$router.replace('/');
      }
    }

    dropdownHided(id: number) {
        const oldState = this.dropdownStates[id];

        setTimeout(() => {
            const newState = this.dropdownStates[id];

            if (newState === oldState) {
                this.dropdownStates = {};
            }
        }, 400);
    }

    gearClick (id: number) {
        const dropdown = this.$refs['actionDropdown' + id];

        if (dropdown) {
            if (this.dropdownStates[id]) {
                this.dropdownStates[id] = false;
            } else {
                this.dropdownStates = {
                    [id]: true,
                };

                this.$nextTick(() => {
                    (dropdown as any).show();

                    if ((dropdown as Vue).$el.children[1]) {
                        if (16 + (dropdown as Vue).$el.children[1].children.length * 24 >= (55 * this.usersList.length)) {
                            ((dropdown as Vue).$el.children[1] as HTMLElement).style.marginRight = '50px';
                        }
                    }
                })
            }
        }
    }
  }
